import Joi from 'joi-browser';
const dateFormat = 'MM/DD/YYYY HH:mm';
export function getPlanDetailsConfig() {
    return {
        fieldTypes: {
            taxQualified: {
                fieldName: "Is this Plan Tax Qualified",
                required: true,
                type: "button",
                fullWidth: true,
                options: [{
                        key: "yes",
                        value: "Yes"
                    },
                    {
                        key: "no",
                        value: "No"
                    }
                ]
            },
            employeeDiscount: {
                fieldName: "Employee Discount",
                required: true,
                type: "number",
                minimum: 0,
                maximum: 100,
                append: "%",
            },
            offeringPeriod: {
                fieldName: "Offering Period",
                type: "dropdown",
                required: true,
                options: [{
                        key: "3",
                        value: "3 Months"
                    },
                    {
                        key: "6",
                        value: "6 Months"
                    },
                    {
                        key: "12",
                        value: "12 Months"
                    },
                    {
                        key: "18",
                        value: "18 Months"
                    },
                    {
                        key: "24",
                        value: "24 Months"
                    },
                ],
            },
            purchasePeriod: {
                fieldName: "Purchase Period",
                type: "dropdown",
                required: true,
                options: [{
                        key: "3",
                        value: "3 Months"
                    },
                    {
                        key: "6",
                        value: "6 Months"
                    },
                    {
                        key: "12",
                        value: "12 Months"
                    },
                ],
            },
            LookbackAllowed: {
                fieldName: "Lookback Allowed",
                required: true,
                key: "Lookback",
                type: "button",
                grouped: true,
                options: [{
                        key: "yes",
                        value: "Yes"
                    },
                    {
                        key: "no",
                        value: "No"
                    }
                ]
            },
            resetAllowed: {
                fieldName: "Reset",
                key: "Reset",
                required: true,
                type: "button",
                grouped: true,
                options: [{
                        key: "yes",
                        value: "Yes"
                    },
                    {
                        key: "no",
                        value: "No"
                    }
                ]
            },
            increasesAllowed: {
                fieldName: "Increases Allowed",
                required: true,
                type: "dropdown",
                options: [{
                        key: "0",
                        value: "0"
                    },
                    {
                        key: "1",
                        value: "1"
                    },
                    {
                        key: "2",
                        value: "2"
                    },
                    {
                        key: "3",
                        value: "3"
                    },
                ],
            },
            decreasesAllowed: {
                fieldName: "Decreases Allowed",
                required: true,
                type: "dropdown",
                options: [{
                        key: "0",
                        value: "0"
                    },
                    {
                        key: "1",
                        value: "1"
                    },
                    {
                        key: "2",
                        value: "2"
                    },
                    {
                        key: "3",
                        value: "3"
                    },
                ],
            },
            enrollmentStarts: {
                fieldName: "Enrollment Starts (days before Period Start date)",
                required: true,
                type: "number",
            },
            enrollmentEnds: {
                fieldName: "Enrollment Ends (days before Period Start date)",
                required: true,
                type: "number"
            },
            minStockAmount: {
                fieldName: "Min Stock Amount",
                required: false,
                type: "number",
                minimum: 0,
                maximum: 100,
                checkbox: "No Limit"
            },
            maxStockAmount: {
                fieldName: "Max Stock Amount",
                required: false,
                type: "number",
                minimum: 0,
                maximum: 100,
                checkbox: "No Limit"
            },
            minDollarAmount: {
                fieldName: "Min Dollar Contribution Amount",
                required: true,
                type: "number",
                minimum: 0,
                maximum: 100,
                append: "$",
                checkbox: "No Limit"
            },
            maxDollarAmount: {
                fieldName: "Max Dollar Annual Contribution Amount",
                required: true,
                type: "number",
                minimum: 0,
                maximum: 100,
                append: "$",
            },
            minPercentAmount: {
                fieldName: "Min Percent Amount",
                required: false,
                type: "number",
                minimum: 0,
                maximum: 100,
                append: "%"
            },
            maxPercentAmount: {
                fieldName: "Max Percent Amount",
                required: false,
                type: "number",
                minimum: 0,
                maximum: 100,
                append: "%"
            },
            fractionalShares: {
                fieldName: "Fractional Shares Offered?",
                required: true,
                type: "button",
                fullWidth: true,
                options: [{
                        key: "yes",
                        value: "Yes"
                    },
                    {
                        key: "no",
                        value: "No"
                    }
                ]
            },
            fractionalDigits: {
                fieldName: "Fractional Digits Allowed",
                required: false,
                type: "button",
                fullWidth: true,
                options: [{
                        key: 2,
                        value: "2 Decimal Places (0.01)"
                    },
                    {
                        key: 3,
                        value: "3 Decimal Places (0.001)"
                    },
                    {
                        key: 4,
                        value: "4 Decimal Places (0.0001)"
                    }
                ]
            },
            offerStartdate: {
                fieldName: "Offer Period Start Date",
                type: 'date',
                dateformat: dateFormat,
                required: false
            },
            timeZone: {
                fieldName: "Timezone",
                type: 'number',
                category:'hidden',                
                required: false
            }   
        },

        validationSchema: Joi.object().keys({
            id: Joi.string(),
            taxQualified: Joi.string().required().valid("Yes", "No"),
            employeeDiscount: Joi.number().min(0).max(100).required(),
            purchasePeriod: Joi.string().valid("3", "6", "12").required(),
            offeringPeriod: Joi.string().valid("3", "6", "12", "18", "24").required(),
            LookbackAllowed: Joi.string().required().valid("Yes", "No"),
            increasesAllowed: Joi.number().min(0).max(100).required(),
            decreasesAllowed: Joi.number().min(0).max(100).required(),
            resetAllowed: Joi.string().required().valid("Yes", "No"),
            fractionalShares: Joi.string().required().valid("Yes", "No"),
            enrollmentStarts: Joi.number().min(1).max(60).required(),
            enrollmentEnds: Joi.number().min(0).required().max(Joi.ref('enrollmentStarts')),
            maxDollarAmount: Joi.number().required(),
            maxPercentAmount: Joi.number(),
            maxStockAmount: Joi.number(),
            minDollarAmount: Joi.number().required(),
            minStockAmount: Joi.number(),
            offerStartdate: Joi.date(),
            timeZone:Joi.string(),
            fractionalDigits: Joi.string()
                .when("fractionalShares", {
                    is: "Yes",
                    then: Joi.string().required().min(2)
                })
        }).unknown(true)
    }
}